/* Action types with TypeScript type declaration */

/* Data pending types */

export const CATEGORIES_PENDING = 'rpb2b-react/categories/CATEGORIES_PENDING';
export type CATEGORIES_PENDING = typeof CATEGORIES_PENDING;

export const SUBCATEGORIES_PENDING =
  'rpb2b-react/categories/SUBCATEGORIES_PENDING';
export type SUBCATEGORIES_PENDING = typeof SUBCATEGORIES_PENDING;

export const SUBCATEGORIES_FILTERS_PENDING =
  'rpb2b-react/categories/SUBCATEGORIES_FILTERS_PENDING';
export type SUBCATEGORIES_FILTERS_PENDING = typeof SUBCATEGORIES_FILTERS_PENDING;

export const PRODUCTS_PENDING = 'rpb2b-react/categories/PRODUCTS_PENDING';
export type PRODUCTS_PENDING = typeof PRODUCTS_PENDING;

export const FILTERED_PRODUCTS_PENDING =
  'rpb2b-react/categories/FILTERED_PRODUCTS_PENDING';
export type FILTERED_PRODUCTS_PENDING = typeof FILTERED_PRODUCTS_PENDING;

/* Data setting */

export const SET_CATEGORIES = 'rpb2b-react/categories/SET_CATEGORIES';
export type SET_CATEGORIES = typeof SET_CATEGORIES;

export const SET_SUBCATEGORIES = 'rpb2b-react/categories/SET_SUBCATEGORIES';
export type SET_SUBCATEGORIES = typeof SET_SUBCATEGORIES;

export const SET_PRODUCTS = 'rpb2b-react/categories/SET_PRODUCTS';
export type SET_PRODUCTS = typeof SET_PRODUCTS;

/* Filters */

export const SET_CATEGORIES_FILTERS =
  'rpb2b-react/categories/SET_CATEGORIES_FILTERS';
export type SET_CATEGORIES_FILTERS = typeof SET_CATEGORIES_FILTERS;

export const SET_ACTIVE_SUBCATEGORY =
  'rpb2b-react/categories/SET_ACTIVE_SUBCATEGORY';
export type SET_ACTIVE_SUBCATEGORY = typeof SET_ACTIVE_SUBCATEGORY;

export const SET_ACTIVE_FILTERS = 'rpb2b-react/categories/SET_ACTIVE_FILTERS';
export type SET_ACTIVE_FILTERS = typeof SET_ACTIVE_FILTERS;

export const SET_FILTERED_PRODUCTS =
  'rpb2b-react/categories/SET_FILTERED_PRODUCTS';
export type SET_FILTERED_PRODUCTS = typeof SET_FILTERED_PRODUCTS;

/* Error handling */

export const CATEGORIES_ERROR = 'rpb2b-react/categories/CATEGORIES_ERROR';
export type CATEGORIES_ERROR = typeof CATEGORIES_ERROR;

export default {
  CATEGORIES_PENDING,
  SUBCATEGORIES_PENDING,
  SUBCATEGORIES_FILTERS_PENDING,
  PRODUCTS_PENDING,
  FILTERED_PRODUCTS_PENDING,
  SET_CATEGORIES,
  SET_SUBCATEGORIES,
  SET_PRODUCTS,
  SET_CATEGORIES_FILTERS,
  SET_ACTIVE_SUBCATEGORY,
  SET_ACTIVE_FILTERS,
  SET_FILTERED_PRODUCTS,
  CATEGORIES_ERROR
};
